import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { PlusIcon, XMarkIcon } from "@heroicons/react/24/outline";
import ModernEmployeeSelector from "../../utils/Selector/ModernEmployeeSelector";

export function contactUserIdFrom(user) {
  if (user == null) return null;
  return user.id ?? user.user_id ?? null;
}

export function contactUserFromOpening(opening) {
  if (!opening) return null;
  if (opening.contact_user && contactUserIdFrom(opening.contact_user)) {
    return opening.contact_user;
  }
  const id = opening.contact_user_id;
  if (!id) return null;
  return {
    id,
    displayTitle: opening.contact_name || undefined,
    name: opening.contact_name || undefined,
    email: opening.contact_email || undefined,
    mobile: opening.contact_phone || undefined,
    mobile_work: opening.contact_phone || undefined,
  };
}

export default function JobOpeningContactPicker({ value, onChange }) {
  const { t } = useTranslation();
  const [pickerOpen, setPickerOpen] = useState(false);
  const selected = value?.id ? value : null;

  const applySelection = (employees) => {
    const next = Array.isArray(employees) ? employees[0] || null : employees || null;
    onChange(next);
  };

  return (
    <div>
      <label className="mb-1 block text-sm font-semibold text-slate-700">
        {t("hr.job_openings.fields.contact_user")}
      </label>
      <p className="mb-2 text-xs text-slate-500">
        {t("hr.job_openings.fields.contact_user_hint")}
      </p>

      {selected ? (
        <div className="flex items-start justify-between gap-3 rounded-2xl border border-slate-200 bg-slate-50/50 px-3 py-2">
          <div className="min-w-0">
            <div className="truncate text-sm font-medium text-slate-900">
              {selected.displayTitle || selected.name || selected.email}
            </div>
            {selected.email ? (
              <div className="truncate text-xs text-slate-500">{selected.email}</div>
            ) : null}
          </div>
          <button
            type="button"
            onClick={() => onChange(null)}
            className="rounded-full p-1.5 text-slate-400 hover:bg-white hover:text-slate-700"
            title={t("hr.job_openings.fields.contact_user_clear")}
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>
      ) : (
        <p className="rounded-2xl border border-dashed border-slate-200 bg-slate-50/70 px-3 py-3 text-sm text-slate-500">
          {t("hr.job_openings.fields.contact_user_empty")}
        </p>
      )}

      <button
        type="button"
        onClick={() => setPickerOpen(true)}
        className="mt-3 inline-flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-800 shadow-sm hover:bg-slate-50"
      >
        <PlusIcon className="h-4 w-4" />
        {selected
          ? t("hr.job_openings.fields.contact_user_change")
          : t("hr.job_openings.fields.contact_user_pick")}
      </button>

      {pickerOpen ? (
        <ModernEmployeeSelector
          open
          useDialog
          multiple={false}
          selectedEmployees={selected ? [selected] : []}
          onChange={applySelection}
          onClose={() => setPickerOpen(false)}
        />
      ) : null}
    </div>
  );
}
